import React, { useRef, useEffect } from "react";
import Container from "../../UI/Container/Container";
import image from "../../../assets/images/student-life--spring--resized.jpg";
import classes from "./Stats.module.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const Stats = (props) => {
  gsap.registerPlugin(ScrollTrigger);

  const sectionRef = useRef(null);
  const imageRef = useRef(null);
  const overlayRef = useRef(null);

  useEffect(() => {
    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: sectionRef.current,
        start: "top 50%",
      },
    });

    timeline.from(imageRef.current, {
      opacity: 0,
      duration: 1,
      ease: "sine.out",
    });

    timeline.from(overlayRef.current, {
      opacity: 0,
      duration: 1,
      ease: "sine.out",
    });
  });

  return (
    <div ref={sectionRef} className={classes.Stats}>
      <img ref={imageRef} src={image} alt="Student relaxing in hammock on campus" />
      <div ref={overlayRef} className={classes.Overlay}>
        <Container>
          <div className={classes.Content}>
            <div className={classes.Row}>
              <div className={classes.Stat}>
                <h2>
                  <span>8</span> Greek organizations
                </h2>
              </div>
              <div className={classes.Stat}>
                <h2>
                  <span>7</span> student media outlets
                </h2>
                <p>
                  including <em>The Dickinsonian</em> newspaper and WDCV radio
                </p>
              </div>
            </div>
            <div className={classes.Row}>
              <div className={classes.Stat}>
                <h2>
                  <span>38</span> Student Senators
                </h2>
                <p>representing the student body through shared governance</p>
              </div>
              <div className={classes.Stat}>
                <h2>
                  <span>120+</span> clubs and intramural sports
                </h2>
              </div>
            </div>
            <div className={classes.Row}>
              <p>
                Sampling of student-run clubs & organizations: Mermaid Players, Junkyard Turkeys Ultimate Frisbee, Student Senate, Dirigible Plums
                (Quidditch), Black Student Union, Gaming Club, Spectrum, Student Investment Group, The Idea Fund
              </p>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default Stats;
